// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"50024842","977":"6115fea1"}[chunkId] + ".chunk.js";
};